import { ReactComponent as NotFoundIcon } from './investigation.svg'
import "./pageNotFound.scss";

const PageNotFound = () => {
    return (
        <div className="xsd-page-not-found msds-block-padding-large msds-bg-gray-1">
            <NotFoundIcon className="xsd-page-not-found__icon" />
            <h2>
                <div className="msds-text-header-1-bold msds-text-dark-blue">The page can’t be found </div>
            </h2>
            <div className="msds-text-body-0 msds-text-gray-10">Try using the build in navigation, or retyping the URL</div>
        </div>
    )
}

export default PageNotFound